import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { Severity } from 'api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'comp-severity-tag',
  imports: [NgClass, TranslateModule],
  templateUrl: 'severity-tag.component.html',
  styleUrls: ['severity-tag.component.scss'],
})
export class SeverityTagComponent {
  severity = input.required<Severity>();
}
